<script setup lang="ts">
import { personAdd, mailOpen } from "ionicons/icons";

import {
  IonPage,
  IonItem,
  IonFooter,
  IonContent,
  IonInput,
  IonButton,
  IonLoading,
  IonNote,
  IonIcon,
  IonTitle,
  IonButtons,
  IonHeader,
  IonToolbar,
  IonBackButton,
  useIonRouter,
} from "@ionic/vue";
import { reactive } from "vue";
import { useUserStore } from "@/stores/user";
import { confirmEmail } from "@/api/auth";
import { useForm } from "@/views";
import { useToasters } from "@/composition/toasters";
import { addUser } from "@/api/users";
import { useWindowWidth } from "@/composition/window";

const { isMobile } = useWindowWidth();

const router = useIonRouter();

const userStore = useUserStore();

const form = useForm();

const toasters = useToasters();

const state = reactive({
  loading: false,
  prevkey: "",
  confirmkey: "",
  wrong_key: false,
});

const validateCode = () => {
  state.wrong_key = false;
  if (/[a-zA-Z]/.test(state.confirmkey)) {
    state.confirmkey = state.prevkey;
  } else {
    state.prevkey = state.confirmkey;
  }
};

const validateEmail = () => {
  state.loading = true;

  confirmEmail({
    email: form.user.email,
    confirmkey: state.confirmkey,
  })
    .then(() => {
      userStore
        .login({
          username: form.user.email,
          password: form.user.password,
        })
        .then(() => {
          userStore.fetchMe().then(() => {
            userStore.fetchRoles().then(() => {
              state.loading = false;
              router.push("/onboarding/welcome");
            });
          });
        })
        .catch(() => {
          state.loading = false;
        });
    })
    .catch(() => {
      state.loading = false;
      state.wrong_key = true;
    });
};

const resendKey = () => {
  state.loading = true;

  addUser(form.user)
    .then(() => {
      state.loading = false;
      toasters.addSuccess("Please check your inbox");
    })
    .catch(() => {
      toasters.addError("Error sending email, please try again");
    });
};
</script>

<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button
            color="white"
            default-href="/onboarding/introduction"
          ></ion-back-button>
        </ion-buttons>
        <ion-title>Email verification</ion-title>

        <!-- <ion-progress-bar :value="0.5"></ion-progress-bar> -->
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div class="container">
        <section>
          <h1>Check your email</h1>
          <p>Please enter the 6 digit code <br />sent to your email.</p>

          <ion-item
            class="ion-text-center"
            :class="{ 'ion-invalid': state.wrong_key }"
            style="margin: 20px"
            fill="outline"
          >
            <ion-input
              type="text"
              v-model="state.confirmkey"
              :maxlength="6"
              @input="validateCode()"
            ></ion-input>
            <ion-note slot="error"> This key is invalid </ion-note>
          </ion-item>

          <ion-icon
            :icon="mailOpen"
            color="light"
            style="margin: 0 auto; font-size: 6rem; display: block"
          ></ion-icon>

          <div class="flex-desktop buttons-container" v-if="!isMobile">
            <ion-button
              expand="block"
              fill="clear"
              class="ion-margin-bottom"
              @click="resendKey()"
            >
              Resend code
            </ion-button>
            <ion-button expand="block" color="primary" @click="validateEmail()">
              <ion-icon slot="start" :icon="personAdd"></ion-icon>
              Continue
            </ion-button>
          </div>
        </section>
      </div>
    </ion-content>

    <ion-footer v-if="isMobile">
      <div class="container">
        <section>
          <ion-button
            expand="block"
            fill="clear"
            class="ion-margin-bottom"
            @click="resendKey()"
          >
            Resend code
          </ion-button>
          <ion-button expand="block" color="primary" @click="validateEmail()">
            <ion-icon slot="start" :icon="personAdd"></ion-icon>
            Continue
          </ion-button>
        </section>
      </div>
    </ion-footer>
    <ion-loading :is-open="state.loading" message="Please wait...">
    </ion-loading>
  </ion-page>
</template>

<style scoped lang="scss">
.buttons-container {
  justify-content: center;
  margin-top: 30px;
}
</style>
